export default __webpack_public_path__ + "static/media/parc1.658755b4.png";